import { Component, inject, OnInit } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { DialogComponent } from '@ui/Components/Dialog/Dialog.Component'
import { createGuest } from '@client/utils'
import { ToolbarComponent } from '@ui/Components/Toolbar/Toolbar.Component'
import { GuestFormComponent } from '@client/Components/Guests/Form/GuestForm.Component'
import Guest, { STATUS_PENDING } from '@client/Guest'
import { GuestService } from '@client/Services/GuestService'
import { PermissionsService } from '@client/Services/PermissionsService'

@Component({
	selector: 'create-guest-dialog-component',
	templateUrl: './CreateGuest.Dialog.Component.html',
	imports: [DialogComponent, ToolbarComponent, GuestFormComponent],
})
export class CreateGuestDialogComponent implements OnInit {
	protected readonly guest: Guest

	private readonly dialogRef: MatDialogRef<CreateGuestDialogComponent>

	private readonly guestService = inject(GuestService)

	private readonly permissionsService = inject(PermissionsService)

	constructor() {
		this.dialogRef = inject(MatDialogRef<CreateGuestDialogComponent>)
		this.guest = createGuest()
		this.guest.status = STATUS_PENDING
	}

	public ngOnInit() {
		this.guest.user_id = this.permissionsService.user.id
	}

	public createGuest = async (guest: Guest): Promise<void> => {
		const apiGuest = await this.guestService.createGuest(guest)

		this.closeDialog(apiGuest)
	}

	public closeDialog = (guest: Guest) => {
		this.dialogRef.close(guest)
	}
}
